import { memo } from 'react';
import './Loading.scss';
import { jsx } from 'react/jsx-runtime';

/* External */
function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/jsx("div", {
    className: "dtv-common-c-loading ".concat(className),
    "data-testid": "loading"
  });
}
Loading.defaultProps = {
  className: ''
};
var Loading$1 = /*#__PURE__*/memo(Loading);

export { Loading$1 as default };
//# sourceMappingURL=Loading.js.map
